<template>
  <va-create-layout>
    <role-form :title="title" :item="item"></role-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
